import { Alert, AlertDescription, AlertTitle } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import BulletList from './_BulletList'

interface FinanceAlertProps {
  financialDocumentsCount: number
  bankAccountsCount: number
}

const FinanceAlert = ({ financialDocumentsCount, bankAccountsCount }: FinanceAlertProps) => {
  const items = [
    ...(financialDocumentsCount > 0
      ? [
          i18n.t(
            'settings.legal_entities.legal_entity.remove.blocked_by_finance.financial_documents',
            { count: financialDocumentsCount }
          ),
        ]
      : []),
    ...(bankAccountsCount > 0
      ? [
          i18n.t('settings.legal_entities.legal_entity.remove.blocked_by_finance.bank_accounts', {
            count: bankAccountsCount,
          }),
        ]
      : []),
  ]

  return (
    <Alert variant="destructive">
      <AlertTitle>
        {i18n.t('settings.legal_entities.legal_entity.remove.blocked_by_finance.title')}
      </AlertTitle>
      <AlertDescription>
        <BulletList items={items} />
        {i18n.t('settings.legal_entities.legal_entity.remove.blocked_by_finance.contact_message')}
      </AlertDescription>
    </Alert>
  )
}

export default FinanceAlert
